import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "verpal-detail" }
const _hoisted_2 = { class: "px-4 py-4" }
const _hoisted_3 = {
  class: "header p-4 rounded-md",
  style: {"background-color":"#EFF5FF"}
}
const _hoisted_4 = { class: "flex w-full justify-between mb-2 items-start md:items-center gap-4" }
const _hoisted_5 = { class: "font-bold break-all md:break-normal" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "inline-flex gap-2 items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-check font-bold text-sm text-white" }),
  /*#__PURE__*/_createElementVNode("p", { class: "text-white font-bold text-sm" }, "Approved")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "inline-flex gap-2 items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-check font-bold text-sm text-white" }),
  /*#__PURE__*/_createElementVNode("p", { class: "text-white font-bold text-sm" }, "Approve")
], -1)
const _hoisted_8 = { class: "block md:flex gap-4 mb-2 items-center" }
const _hoisted_9 = { class: "flex items-center gap-1 mb-2" }
const _hoisted_10 = { class: "text-grey-5 font-bold text-sm" }
const _hoisted_11 = { class: "block sm:flex gap-4 mb-2 items-center" }
const _hoisted_12 = { class: "flex items-center gap-1 mb-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user text-sm font-bold" }, null, -1)
const _hoisted_14 = { class: "text-grey text-sm font-bold" }
const _hoisted_15 = { class: "flex items-center gap-1 mb-2" }
const _hoisted_16 = { class: "text-grey text-sm font-bold" }
const _hoisted_17 = { class: "flex items-center gap-1 mb-2" }
const _hoisted_18 = { class: "text-grey text-sm font-bold" }
const _hoisted_19 = { class: "grid grid-cols-1 lg:grid-cols-2 mt-5 gap-6" }
const _hoisted_20 = { class: "mb-4 border-bottom-grey-2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "text-neutral-500 font-extrabold text-sm mb-2" }, "Perihal Laporan", -1)
const _hoisted_22 = { class: "font-semibold" }
const _hoisted_23 = { class: "mb-4 border-bottom-grey-2" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", { class: "text-neutral-500 font-extrabold text-sm mb-2" }, "Kota Kejadian", -1)
const _hoisted_25 = { class: "font-semibold" }
const _hoisted_26 = { class: "mb-4" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", { class: "text-neutral-500 font-extrabold text-sm mb-2" }, "Keterangan Pelapor", -1)
const _hoisted_28 = { class: "font-semibold mb-2" }
const _hoisted_29 = { class: "grid grid-cols-4 gap-4" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "text-neutral-500 font-extrabold text-sm mb-2" }, "Lokasi Kejadian", -1)
const _hoisted_31 = {
  id: "mapDiv",
  ref: "mapDiv",
  class: "mapDiv",
  style: {"height":"90%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InlineSvg = _resolveComponent("InlineSvg")!
  const _component_SilentBoxSingle = _resolveComponent("SilentBoxSingle")!
  const _component_Card = _resolveComponent("Card")!
  const _component_HjpCofirmModal = _resolveComponent("HjpCofirmModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Card, { class: "card-no-shadow" }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.dataDetail?.TransactionPp.RosterCode), 1),
              (_ctx.dataDetail?.MsStatus.Code === _ctx.StatusVerpal.Approved)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    class: "",
                    disabled: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    class: "",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.approveAct(_ctx.dataDetail?.Id)))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }))
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_InlineSvg, {
                  src: require('@/assets/img/icon/arrow-circle-right-outline-blue.svg')
                }, null, 8, ["src"]),
                _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.dataDetail?.TransactionPp.RosterCode), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.dataDetail?.TransactionPp.CondecturName), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_InlineSvg, {
                  src: require('@/assets/img/icon/steering-wheel.svg')
                }, null, 8, ["src"]),
                _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.dataDetail?.DriverName), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_InlineSvg, {
                  src: require('@/assets/img/icon/truck-outline-black.svg')
                }, null, 8, ["src"]),
                _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.dataDetail?.TransactionPp.VehicleRegNumber), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.dataDetail?.Description), 1)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.dataDetail?.CurrentTerminal), 1)
              ]),
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.dataDetail?.Description), 1),
                _createElementVNode("div", _hoisted_29, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataDetail?.VerpalMedia, (img, idx) => {
                    return (_openBlock(), _createBlock(_component_SilentBoxSingle, {
                      key: idx,
                      image: img
                    }, null, 8, ["image"]))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_30,
              _createElementVNode("div", _hoisted_31, null, 512)
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_HjpCofirmModal, {
      show: _ctx.attrModalConfirmation.show,
      imgContent: _ctx.attrModalConfirmation.imgContent,
      title: _ctx.attrModalConfirmation.title,
      subTitle: _ctx.attrModalConfirmation.subTitle,
      btnSubmitTitle: _ctx.attrModalConfirmation.btnSubmitTitle,
      onHideDialog: _ctx.hideDialogConfirmation,
      onOnSubmit: _ctx.onSubmitConfirmation
    }, null, 8, ["show", "imgContent", "title", "subTitle", "btnSubmitTitle", "onHideDialog", "onOnSubmit"])
  ]))
}